export interface StandardSemiboldTextProps {
  text: string;
}

const StandardSemiboldText = (props: StandardSemiboldTextProps) => {
  return <p className="text-base text-text font-semibold">{props.text}</p>;
};

export default StandardSemiboldText;
